/* tslint:disable */
/* eslint-disable */
/**
 * orderControlManage API
 * 発注管理情報に対する情報を操作するAPI群
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 入荷情報
 * @export
 * @interface Arrival
 */
export interface Arrival {
    /**
     * 入荷ID
     * @type {string}
     * @memberof Arrival
     */
    'arrivalId'?: string;
    /**
     * 入荷年
     * @type {number}
     * @memberof Arrival
     */
    'targetYear'?: number;
    /**
     * 入荷月
     * @type {number}
     * @memberof Arrival
     */
    'targetMonth'?: number;
    /**
     * 入荷数量
     * @type {number}
     * @memberof Arrival
     */
    'arrivalAmount'?: number;
}
/**
 * 客先内示サマリ情報
 * @export
 * @interface CustomerAnnounceSummary
 */
export interface CustomerAnnounceSummary {
    /**
     * 客先内示サマリID
     * @type {string}
     * @memberof CustomerAnnounceSummary
     */
    'customerAnnounceSummaryId'?: string;
    /**
     * 客先内示受領年
     * @type {number}
     * @memberof CustomerAnnounceSummary
     */
    'customerAnnounceReceivedYear'?: number;
    /**
     * 客先内示受領月
     * @type {number}
     * @memberof CustomerAnnounceSummary
     */
    'customerAnnounceReceivedMonth'?: number;
    /**
     * 客先内示対象年
     * @type {number}
     * @memberof CustomerAnnounceSummary
     */
    'customerAnnounceTargetYear'?: number;
    /**
     * 客先内示対象月
     * @type {number}
     * @memberof CustomerAnnounceSummary
     */
    'customerAnnounceTargetMonth'?: number;
    /**
     * 客先内示数量
     * @type {number}
     * @memberof CustomerAnnounceSummary
     */
    'customerForecastAmountTotal'?: number;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * getした時にレスポンスで受け取る情報の型定義 (承認依頼情報を持つ集計ID一覧取得)
 * @export
 * @interface GetApprovedRequestOrderIdsResponse
 */
export interface GetApprovedRequestOrderIdsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetApprovedRequestOrderIdsResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetApprovedRequestOrderIdsResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetApprovedRequestOrderIdsResponse
     */
    'message': string;
    /**
     * 
     * @type {GetApprovedRequestOrderIdsResponseResult}
     * @memberof GetApprovedRequestOrderIdsResponse
     */
    'result': GetApprovedRequestOrderIdsResponseResult;
}
/**
 * APIから受け取るレスポンスの型 (承認依頼情報を持つ集計ID一覧取得)
 * @export
 * @interface GetApprovedRequestOrderIdsResponseResult
 */
export interface GetApprovedRequestOrderIdsResponseResult {
    /**
     * 集計ID一覧
     * @type {Array<string>}
     * @memberof GetApprovedRequestOrderIdsResponseResult
     */
    'aggregateBusinessIds': Array<string>;
}
/**
 * getした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface GetOrderControlResponse
 */
export interface GetOrderControlResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOrderControlResponseResult}
     * @memberof GetOrderControlResponse
     */
    'result': GetOrderControlResponseResult;
}
/**
 * APIから受け取るレスポンスの型
 * @export
 * @interface GetOrderControlResponseResult
 */
export interface GetOrderControlResponseResult {
    /**
     * 発注管理情報に必要なデータ
     * @type {Array<GetOrderControlResponseResultDataInner>}
     * @memberof GetOrderControlResponseResult
     */
    'data': Array<GetOrderControlResponseResultDataInner>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetOrderControlResponseResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * 
 * @export
 * @interface GetOrderControlResponseResultDataInner
 */
export interface GetOrderControlResponseResultDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'orderStatus': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'createdOrderDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'orderAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'desiredDeliveryDate': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'warehouse': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'supplierNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'businessName': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'package': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'unit': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'leadTime': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'stdInventoryIndicesMin': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'stdInventoryIndicesMax': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'stdInventoryIndicesUnit': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 
     * @type {Array<Arrival>}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'arrivals': Array<Arrival>;
    /**
     * 
     * @type {Array<SalesResultSummary>}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'salesResults': Array<SalesResultSummary>;
    /**
     * 
     * @type {Array<Inventory>}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'inventories': Array<Inventory>;
    /**
     * 
     * @type {Array<CustomerAnnounceSummary>}
     * @memberof GetOrderControlResponseResultDataInner
     */
    'customerAnnounces': Array<CustomerAnnounceSummary>;
}
/**
 * getした時にレスポンスで受け取る情報の型定義 (推奨情報を持つ集計ID一覧取得)
 * @export
 * @interface GetRecommendOrderIdsResponse
 */
export interface GetRecommendOrderIdsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRecommendOrderIdsResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetRecommendOrderIdsResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendOrderIdsResponse
     */
    'message': string;
    /**
     * 
     * @type {GetRecommendOrderIdsResponseResult}
     * @memberof GetRecommendOrderIdsResponse
     */
    'result': GetRecommendOrderIdsResponseResult;
}
/**
 * APIから受け取るレスポンスの型 (推奨情報を持つ集計ID一覧取得)
 * @export
 * @interface GetRecommendOrderIdsResponseResult
 */
export interface GetRecommendOrderIdsResponseResult {
    /**
     * 集計ID一覧
     * @type {Array<string>}
     * @memberof GetRecommendOrderIdsResponseResult
     */
    'aggregateBusinessIds': Array<string>;
}
/**
 * 在庫情報
 * @export
 * @interface Inventory
 */
export interface Inventory {
    /**
     * 在庫ID
     * @type {string}
     * @memberof Inventory
     */
    'inventoryId'?: string;
    /**
     * 在庫年
     * @type {number}
     * @memberof Inventory
     */
    'inventoriedTargetYear'?: number;
    /**
     * 在庫月
     * @type {number}
     * @memberof Inventory
     */
    'inventoriedTargetMonth'?: number;
    /**
     * 在庫年月日
     * @type {number}
     * @memberof Inventory
     */
    'inventoriedDate'?: number;
    /**
     * 在庫数量
     * @type {number}
     * @memberof Inventory
     */
    'inventoryAmount'?: number;
}
/**
 * objectで渡すフィルターの情報
 * @export
 * @interface ObjectFilterInfo
 */
export interface ObjectFilterInfo {
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮したリードタイム情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'leadTimeInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(min)情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'stdInventoryIndexMinInfoList'?: string;
    /**
     * [{value: number, unit: string}]のようなデータをJSONにし、それをzlibを用いて圧縮した標準在庫指数(max)情報
     * @type {string}
     * @memberof ObjectFilterInfo
     */
    'stdInventoryIndexMaxInfoList'?: string;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 販売実績サマリ
 * @export
 * @interface SalesResultSummary
 */
export interface SalesResultSummary {
    /**
     * 販売実績サマリID
     * @type {string}
     * @memberof SalesResultSummary
     */
    'salesResultIdSummary'?: string;
    /**
     * 販売実績対象年
     * @type {number}
     * @memberof SalesResultSummary
     */
    'salesResultTargetYear'?: number;
    /**
     * 販売実績対象月
     * @type {number}
     * @memberof SalesResultSummary
     */
    'salesResultTargetMonth'?: number;
    /**
     * 販売数量
     * @type {number}
     * @memberof SalesResultSummary
     */
    'salesResultAmountTotal'?: number;
}
/**
 * ソート種別
 * @export
 * @enum {string}
 */

export const SortType = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortType = typeof SortType[keyof typeof SortType];


/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * リクエストに含めるフィルター項目の型 (発注管理ページ用)
 * @export
 * @interface UseFilterItemForOrderControlManage
 */
export interface UseFilterItemForOrderControlManage {
    /**
     * 仕入先名
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'supplierName'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'warehouse'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof UseFilterItemForOrderControlManage
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'manufacturer'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'salesDestinationName'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'customerName'?: string;
    /**
     * 発注数量
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'orderAmount'?: string;
    /**
     * 発注日
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'createdOrderDate'?: string;
    /**
     * 希望納期
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'desiredDeliveryDate'?: string;
    /**
     * 集計取引担当者ID
     * @type {string}
     * @memberof UseFilterItemForOrderControlManage
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 最終チェック日時(開始, ms)
     * @type {number}
     * @memberof UseFilterItemForOrderControlManage
     */
    'lastCheckedAtFrom'?: number;
    /**
     * 最終チェック日時(終了, ms)
     * @type {number}
     * @memberof UseFilterItemForOrderControlManage
     */
    'lastCheckedAtTo'?: number;
    /**
     * 最終チェック日時が未設定のデータも含める
     * @type {boolean}
     * @memberof UseFilterItemForOrderControlManage
     */
    'lastCheckedAtIncludeNull'?: boolean;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}

/**
 * GetApprovedRequestOrderIdsApi - axios parameter creator
 * @export
 */
export const GetApprovedRequestOrderIdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 承認依頼情報もつ集計IDの取得を行う
         * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedRequestOrderIds: async (filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/approved-request-order-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItemObject !== undefined) {
                for (const [key, value] of Object.entries(filterItemObject)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetApprovedRequestOrderIdsApi - functional programming interface
 * @export
 */
export const GetApprovedRequestOrderIdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetApprovedRequestOrderIdsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 承認依頼情報もつ集計IDの取得を行う
         * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovedRequestOrderIds(filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApprovedRequestOrderIdsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovedRequestOrderIds(filterItem, filterItemObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GetApprovedRequestOrderIdsApi.getApprovedRequestOrderIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GetApprovedRequestOrderIdsApi - factory interface
 * @export
 */
export const GetApprovedRequestOrderIdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetApprovedRequestOrderIdsApiFp(configuration)
    return {
        /**
         * 
         * @summary 承認依頼情報もつ集計IDの取得を行う
         * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovedRequestOrderIds(filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options?: any): AxiosPromise<GetApprovedRequestOrderIdsResponse> {
            return localVarFp.getApprovedRequestOrderIds(filterItem, filterItemObject, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetApprovedRequestOrderIdsApi - object-oriented interface
 * @export
 * @class GetApprovedRequestOrderIdsApi
 * @extends {BaseAPI}
 */
export class GetApprovedRequestOrderIdsApi extends BaseAPI {
    /**
     * 
     * @summary 承認依頼情報もつ集計IDの取得を行う
     * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
     * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetApprovedRequestOrderIdsApi
     */
    public getApprovedRequestOrderIds(filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig) {
        return GetApprovedRequestOrderIdsApiFp(this.configuration).getApprovedRequestOrderIds(filterItem, filterItemObject, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GetRecommendOrderIdsApi - axios parameter creator
 * @export
 */
export const GetRecommendOrderIdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 推奨発注ID=推奨情報もつ集計IDの取得を行う
         * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendOrderIds: async (filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recommend-order-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItemObject !== undefined) {
                for (const [key, value] of Object.entries(filterItemObject)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetRecommendOrderIdsApi - functional programming interface
 * @export
 */
export const GetRecommendOrderIdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetRecommendOrderIdsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 推奨発注ID=推奨情報もつ集計IDの取得を行う
         * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendOrderIds(filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecommendOrderIdsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendOrderIds(filterItem, filterItemObject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GetRecommendOrderIdsApi.getRecommendOrderIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GetRecommendOrderIdsApi - factory interface
 * @export
 */
export const GetRecommendOrderIdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetRecommendOrderIdsApiFp(configuration)
    return {
        /**
         * 
         * @summary 推奨発注ID=推奨情報もつ集計IDの取得を行う
         * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
         * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendOrderIds(filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options?: any): AxiosPromise<GetRecommendOrderIdsResponse> {
            return localVarFp.getRecommendOrderIds(filterItem, filterItemObject, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetRecommendOrderIdsApi - object-oriented interface
 * @export
 * @class GetRecommendOrderIdsApi
 * @extends {BaseAPI}
 */
export class GetRecommendOrderIdsApi extends BaseAPI {
    /**
     * 
     * @summary 推奨発注ID=推奨情報もつ集計IDの取得を行う
     * @param {UseFilterItemForOrderControlManage} [filterItem] 列名を指定するフィルター
     * @param {ObjectFilterInfo} [filterItemObject] フィルター項目の内、Objectで指定する必要があるもの(単位と値がセットで指定されるもの)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetRecommendOrderIdsApi
     */
    public getRecommendOrderIds(filterItem?: UseFilterItemForOrderControlManage, filterItemObject?: ObjectFilterInfo, options?: RawAxiosRequestConfig) {
        return GetRecommendOrderIdsApiFp(this.configuration).getRecommendOrderIds(filterItem, filterItemObject, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderControlApi - axios parameter creator
 * @export
 */
export const OrderControlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注管理ページに必要な情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {UseFilterItemForOrderControlManage} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderControlMange: async (sortType: SortType, limit: number, offset: number, filterItem?: UseFilterItemForOrderControlManage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getOrderControlMange', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getOrderControlMange', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getOrderControlMange', 'offset', offset)
            const localVarPath = `/order-control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort-type'] = sortType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderControlApi - functional programming interface
 * @export
 */
export const OrderControlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderControlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注管理ページに必要な情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {UseFilterItemForOrderControlManage} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderControlMange(sortType: SortType, limit: number, offset: number, filterItem?: UseFilterItemForOrderControlManage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderControlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderControlMange(sortType, limit, offset, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderControlApi.getOrderControlMange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderControlApi - factory interface
 * @export
 */
export const OrderControlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderControlApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注管理ページに必要な情報を取得する
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {UseFilterItemForOrderControlManage} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderControlMange(sortType: SortType, limit: number, offset: number, filterItem?: UseFilterItemForOrderControlManage, options?: any): AxiosPromise<GetOrderControlResponse> {
            return localVarFp.getOrderControlMange(sortType, limit, offset, filterItem, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderControlApi - object-oriented interface
 * @export
 * @class OrderControlApi
 * @extends {BaseAPI}
 */
export class OrderControlApi extends BaseAPI {
    /**
     * 
     * @summary 発注管理ページに必要な情報を取得する
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {UseFilterItemForOrderControlManage} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderControlApi
     */
    public getOrderControlMange(sortType: SortType, limit: number, offset: number, filterItem?: UseFilterItemForOrderControlManage, options?: RawAxiosRequestConfig) {
        return OrderControlApiFp(this.configuration).getOrderControlMange(sortType, limit, offset, filterItem, options).then((request) => request(this.axios, this.basePath));
    }
}



